<template>
    <div>
        <v-card flat>
            <v-card-title>Example Files</v-card-title>
            <v-card-text>This file serves as a system demo.  Any reusable components that are used throughout the system should have a corresponding example listed here.
                I'm doing this in an effort to:
                <ul>
                    <li>simplify the process of design sweeps,</li>
                    <li>act as a knowledge repository,</li>
                    <li>be a quick reference-point for what the system actually contains.</li>
                </ul>
            </v-card-text>
        </v-card>


            <!--        CARD FOR LIST FILTERS-->
            <div class="flex flex-row gap-3">
                <div class="flex w-96">
                    <v-text-field
                        v-model="search"
                        outlined
                        label="Search"
                        dense
                        prepend-inner-icon="mdi-magnify"
                    ></v-text-field>
                </div>


            </div>

            <!--        CARD FOR THE LIST-->
            <div class="bordered_up_top">
                <v-card id="table_card" class="d-flex flex-row container-fluid" flat>
                    <v-card-text class="pa-0">
                        <div class="px-7">
                            <v-layout child-flex>
                                <smart-table
                                    id="examplefile_table"
                                    endpoint="examplefiles.list"
                                    :headers="headers"
                                    :search="search"
                                    flat
                                    @click:row="goToDetails"
                                >
                                </smart-table>
                            </v-layout>
                        </div>
                    </v-card-text>

                </v-card>
            </div>
    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import SmartTable from "@/Generic/SmartTable";

export default {
    name: "ExampleFileIndex",
    // To add a new item to this list, create a record for it, and also include it from the ExampleFileShow component too.
    layout: (h, page) => {
        return h(AppLayout, [
            page
        ])
    },
    components: {
        SmartTable,
    },
    props: {
        'constants': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'valuelists': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        }
    },
    data() {
        return {
            search: null,
            filters: {
                id: undefined,
                name: undefined,
                description: undefined,
                type: undefined,
            },
        }
    },
    computed: {
        headers() {
            return [
                {value: 'id',           text: 'ID',             align: `start`,  sortable: true,     filterable: true,   search: this?.filters?.id  },
                {value: 'name',         text: 'Name',           align: `start`,  sortable: true,     filterable: true,   search: this?.filters?.name  },
                {value: 'description',  text: 'Description',    align: `start`,  sortable: true,     filterable: true,   search: this?.filters?.description  },
            ]
        },
    },
    methods: {
        doSomething(item) {
            console.log(item)
        },
        goToDetails(item) {
            this.$inertia.visit(route(`examplefiles.show`, item).url())
        }
    },
}
</script>

<style>
table tr td {
    border-bottom: 0 !important;
}

    .filters_search {
        min-width: 100px; max-width: 100%;
    }

    .filters_select {
        min-width: 100px; max-width: 200px;
    }

    .filters_button {
        min-width: 50px; max-width: 100px;
    }

    .bordered_up_top {
        border-top: 5px solid #4c4c4c !important;
    }
.bordered_up_top {
    border-top: 5px solid #4c4c4c !important;
}

.v-data-table__mobile-row {
    align-items: flex-start;
}

#examplefile_table > .v-data-table__wrapper > table > tbody > tr.v-data-table__mobile-table-row {
    border-top: solid;
    padding-top: 15px;
}

#examplefile_table .v-data-table__mobile-table-row {
    padding-bottom: 15px;
}

</style>
